@if (!isServer) {
  @if (showPopover) {
    <div class="login-wrap">
      <div class="close-btn" (click)="dismiss()">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 24 24">
          <path fill="#3a3a3a"
                d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path>
        </svg>
      </div>

      <div class="login-bg">
        <div class="login-content">
          @if (isWebApp) {
            @if (isDesktop) {
              <div class="wave-sec">
                <div class="ripple-head">
                  <div class="ripple-body">
                    <div class="ripple-wave"></div>
                  </div>
                </div>
                <div class="svg-wrap">
                  <div class="title">BAG2BAG</div>
                  <svg width='143' height='155' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M.46 20.184C.46 9.037 9.497 0 20.645 0h101.534c11.147 0 20.184 9.037 20.184 20.184v164.523H.46V20.185Z'
                      fill='#141823'/>
                    <path
                      d='M7.8 22.02c0-8.108 6.573-14.68 14.68-14.68h97.864c8.107 0 14.68 6.572 14.68 14.68v163.299H7.8v-163.3Z'
                      fill='#fff'/>
                    <path
                      d='M45.11 7.063h52.603v1.282a6.415 6.415 0 0 1-6.415 6.415H51.526a6.415 6.415 0 0 1-6.415-6.415V7.062Z'
                      fill='#141823'/>
                  </svg>
                  <div class="img-sec">
                    <img [ngSrc]="appBarCode" alt="barcode" width="100" height="100"
                         #image
                    >

                  </div>
                  <div class="desc">Scan to Download APP</div>
                </div>
              </div>
              <div class="footer-wrap">
                {{ compData?.container?.description }}
              </div>
            } @else {

            }
          } @else {

          }
        </div>
      </div>
    </div>
  }
}


